const skills = {
        1: [
            {
            title: "HTML",
            level: 6,
        },
        {
            title: "CSS",
            level: 6,
        },
        {
            title: "JavaScript",
            level: 6,
        },
        {
            title: "Python",
            level: 3,
        },
        {
            title: "React",
            level: 6,
        },

    ],

        2: [{
            title: "PostgreSql",
            level: 6,
        },
        {
            title: "Node.js",
            level: 6,
        },
        {
            title: "MongeDB",
            level: 6,
        },
        {
            title: "Git",
            level: 5,
        },
        {
            title: "SQL",
            level: 6,
        },
        
        {
            title: "Express.js",
            level: 6,
        },
        {
            title: "AWS",
            level: 2,
        },
    ],
};

export default skills;